import { TFunction } from 'i18next';

/** Format a date for display */
export default function formatDate(date: Date): string | null {
  if (date.toLocaleDateString() === 'Invalid Date') {
    return null;
  }

  // Target format: June 2, 13:08 UTC
  const hours = (date.getUTCHours() < 10 ? '0' : '') + date.getUTCHours();
  const minutes = (date.getUTCMinutes() < 10 ? '0' : '') + date.getUTCMinutes();
  const options: Intl.DateTimeFormatOptions = { month: 'long', day: 'numeric' };
  // Force US locale to get MMM DD format
  const displayDate = `${date.toLocaleDateString('en-US', options)} ${hours}:${minutes} UTC`;

  return displayDate;
}

export const formatCooldownPeriod = (cooldownPeriodMinutes: number, t: TFunction<'translation', undefined>): string => {
  if (cooldownPeriodMinutes >= 1440) {
    const days = Math.floor(cooldownPeriodMinutes / 1440);
    return days > 1 ? t('common.timeDuration.days', { days }) : t('common.timeDuration.day', { days });
  }
  if (cooldownPeriodMinutes >= 60) {
    const hours = Math.floor(cooldownPeriodMinutes / 60);
    return hours > 1 ? t('common.timeDuration.hours', { hours }) : t('common.timeDuration.hour', { hours });
  }
  const minutes = cooldownPeriodMinutes;
  return minutes > 1 ? t('common.timeDuration.minutes', { minutes }) : t('common.timeDuration.minute', { minutes });
};
